import {
  RUN_QUICK_ACTION_REMOVE_FILE_SUCCESS,
  RUN_QUICK_ACTION_UPLOAD_FILE_ERROR,
  RUN_QUICK_ACTION_UPLOAD_FILE_REQUEST,
  RUN_QUICK_ACTION_UPLOAD_FILE_SUCCESS,
  RUN_QUICK_ACTION_REMOVE_ARRAY_SUCCESS,
} from "../../Types/user/Types";

const initialState = {
  error: "",
  run_uploadFile_data: [],
  loader: false,
};

const Run_quickAction_UploadFileReducer = (state = initialState, action) => {
  switch (action.type) {
    case RUN_QUICK_ACTION_UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        error: "",
        run_uploadFile_data: [...state.run_uploadFile_data, action.payload.data],
        loader: false,
      };
    case RUN_QUICK_ACTION_UPLOAD_FILE_ERROR:
      return {
        ...state,
        error: action.error,
        loader: false,
      };
    case RUN_QUICK_ACTION_UPLOAD_FILE_REQUEST:
      return {
        ...state,
        error: null,
        loader: true,
      };
    case RUN_QUICK_ACTION_REMOVE_FILE_SUCCESS:
      const run_uploadFile_data = state.run_uploadFile_data.filter(file => file.id !== action.payload)
      return {
        ...state,
        error: "",
        run_uploadFile_data,
        loader: false,
      };
      case RUN_QUICK_ACTION_REMOVE_ARRAY_SUCCESS:
      return {
        ...state,
        error: "",
        run_uploadFile_data: [],
        loader: false,
      };
    default:
      return state;
  }
};
export default Run_quickAction_UploadFileReducer;
